module.exports = __webpack_public_path__ + "static/media/HelpAI2_preview.86689c30.jpg";